export default __webpack_public_path__ + "static/reddit-9e04043169e045a469616898bd8b43b7.png";